<script>
import { mapGetters } from 'vuex'
import { isEmpty } from 'lodash'
import Loading from 'vue-loading-overlay'

export default {
  name: 'auth-forgot',

  computed: {
    ...mapGetters(['isLogged']),
    isValid () {
      return !isEmpty(this.forgot.email)
    }
  },
  components: {
    Loading
  },
  data () {
    return {
      loading: false,
      onCancel: false,
      fullPage: true,
      success: null,
      disabled: false,
      msg: null,
      forgot: {
        email: null
      }
    }
  },
  methods: {
    doRecover () {
      this.loading = true
      this.$http.post('/v1/auth/forgot', this.forgot)
        .then(({data}) => {
          this.success = data.message
          this.msg = null
          this.loading = false
          this.forgot.email = null
        }).catch((er) => {
          this.msg = er.meta.message
          this.success = null
          this.loading = false
        })
    }
  }
}
</script>

<template lang="pug">
  .authentication
    .container
      loading(
        :active.sync='loading',
        :can-cancel='true',
        :is-full-page='fullPage',
        color='#7159c1'
      )
      .col-md-12.content-center
        .row
          .col-lg-6.col-md-12
            .company_detail
              h4.logo
                router-link(:to="{name: 'auth.login'}")
                  img(src='/static/images/logo.svg', alt='')
                br
                span(style="font-size: 18px;") Condomum
              //-h3
                strong Bem Vindo
              //-p
                | Acesse seu condominio de forma rápida, prática e segura 24hrs por dia em qualquer lugar.
              .footer
                //-ul.social_link.list-unstyled
                  li
                    a(href='https://thememakker.com', title='ThemeMakker')
                      i.zmdi.zmdi-globe
                  li
                    a(href='https://themeforest.net/user/thememakker', title='Themeforest')
                      i.zmdi.zmdi-shield-check
                  li
                    a(href='https://www.linkedin.com/company/thememakker/', title='LinkedIn')
                      i.zmdi.zmdi-linkedin
                  li
                    a(href='https://www.facebook.com/thememakkerteam', title='Facebook')
                      i.zmdi.zmdi-facebook
                  li
                    a(href='http://twitter.com/thememakker', title='Twitter')
                      i.zmdi.zmdi-twitter
                  li
                    a(href='http://plus.google.com/+thememakker', title='Google plus')
                      i.zmdi.zmdi-google-plus
                  li
                    a(href='https://www.behance.net/thememakker', title='Behance')
                      i.zmdi.zmdi-behance
                hr
                //-ul
                  li
                    a(href='http://thememakker.com/contact/', target='_blank') Contact Us
                  li
                    a(href='http://thememakker.com/about/', target='_blank') About Us
                  li
                    a(href='http://thememakker.com/services/', target='_blank') Services
                  li
                    a(href='javascript:void(0);') FAQ
          .col-lg-5.col-md-12.offset-lg-1
            .card-plain
              .header
                h5 Esqueceu a senha?
                span Informe seu email abaixo para redefinir sua senha.
              form.form
                .input-group
                  input.form-control(
                    type='text',
                    placeholder='Email',
                    v-model="forgot.email")
                  span.input-group-addon
                    i.zmdi.zmdi-email
              .footer
                a.btn.btn-primary.btn-round.btn-block(@click.prevent="doRecover()") RECUPERAR
                strong(style="color: #f96332; font-size: 12px;") {{ success }}
                strong(style="color: #f96332; font-size: 12px;") {{ msg }}
              a.link

</template>



// WEBPACK FOOTER //
// src/app/auth/forgot/forgot.vue